(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Accordion = function Accordion(args) {
	var that = this;

	this.init = function () {
		this.cacheDom();
		bindEvents();
	};

	this.cacheDom = function () {
		this.main_item = document.querySelectorAll(args.main_item);
	};

	function bindEvents() {
		for (var i = 0; i < that.main_item.length; i++) {
			that.main_item[i].addEventListener('click', activate);
		}
	}

	function activate() {
		if (args.collapse) {
			for (var i = 0; i < that.main_item.length; i++) {
				if (i !== [].concat(_toConsumableArray(that.main_item)).indexOf(this)) {
					that.main_item[i].parentNode.classList.remove('is-active');
				}
			}
		}
		this.parentNode.classList.toggle('is-active');
	}
};

module.exports = Accordion;

},{}],2:[function(require,module,exports){
'use strict';

var CookieConsent = function CookieConsent(args) {
	var that = this;

	this.expTime = args.expirationDays;

	this.init = function () {
		this.cacheDom();
		bindEvents();
	};

	this.cacheDom = function () {

		this.cookie = document.querySelector(args.cookieWrapper);
		this.cancel = this.cookie.querySelector(args.cookieCancel);
	};

	function bindEvents() {
		that.cancel.addEventListener('click', hideConsent);

		// check if cookie is already set
		document.cookie.indexOf("cookie-consent") >= 0 ? '' : showConsent();
	}

	function showConsent() {
		that.cookie.classList.add('is-active');
	}

	function hideConsent() {
		that.cookie.classList.remove('is-active');

		// set cookie time expiration
		var expireTime = new Date();
		expireTime.setTime(expireTime.getTime() + 60 * 60 * 24 * 1000 * this.expTime);
		document.cookie = "cookie-consent=true; expires=" + expireTime.toGMTString();
	}
};

module.exports = CookieConsent;

},{}],3:[function(require,module,exports){
'use strict';

if (window.addEventListener && window.requestAnimationFrame && document.getElementsByClassName) window.addEventListener('load', function () {
    // start
    var pItem = document.getElementsByClassName('progressive replace'),
        pCount,
        timer;
    // scroll and resize events
    window.addEventListener('scroll', scroller, false);
    window.addEventListener('resize', scroller, false);
    // DOM mutation observer
    if (MutationObserver) {
        var observer = new MutationObserver(function () {
            if (pItem.length !== pCount) inView();
        });
        observer.observe(document.body, {
            subtree: true,
            childList: true,
            attributes: true,
            characterData: true
        });
    }
    // initial check
    inView();
    // throttled scroll/resize
    function scroller() {
        timer = timer || setTimeout(function () {
            timer = null;
            inView();
        }, 300);
    }
    // image in view?
    function inView() {
        if (pItem.length) requestAnimationFrame(function () {
            var wH = window.innerHeight,
                cRect,
                cT,
                cH,
                p = 0;
            while (p < pItem.length) {
                cRect = pItem[p].getBoundingClientRect();
                cT = cRect.top;
                cH = cRect.height;
                if (0 < cT + cH && wH > cT) {
                    loadFullImage(pItem[p]);
                    pItem[p].classList.remove('replace');
                } else p++;
            }
            pCount = pItem.length;
        });
    }
    // replace with full image
    function loadFullImage(item) {
        var href = item && (item.getAttribute('data-href') || item.href);
        if (!href) return;
        // load image
        var img = new Image();
        if (item.dataset) {
            img.srcset = item.dataset.srcset || '';
            img.sizes = item.dataset.sizes || '';
        }
        img.src = href;
        img.className = 'reveal';
        if (img.complete) addImg();else img.onload = addImg;
        // replace image
        function addImg() {
            requestAnimationFrame(function () {
                // disable click
                if (href === item.href) {
                    item.style.cursor = 'default';
                    item.addEventListener('click', function (e) {
                        e.preventDefault();
                    }, false);
                }
                // preview image
                var pImg = item.querySelector && item.querySelector('img.preview');
                // add full image
                item.insertBefore(img, pImg && pImg.nextSibling).addEventListener('animationend', function () {
                    // remove preview image
                    if (pImg) {
                        img.alt = pImg.alt || '';
                        item.removeChild(pImg);
                    }
                    img.classList.remove('reveal');
                });
            });
        }
    }
}, false);

},{}],4:[function(require,module,exports){
'use strict';

var MobileNavigation = function MobileNavigation(args) {
    var that = this;
    this.flag = false;

    this.init = function () {
        this.cacheDom();
        bindEvents();
    };

    this.cacheDom = function () {
        this.activator = document.querySelector(args.activator);
        this.cancel = document.querySelector(args.cancel);
        this.header = document.querySelector(args.header);
        this.overlay = document.querySelector(args.overlay);
    };

    function bindEvents() {
        that.activator.addEventListener('click', function () {
            that.showHide();
        });
        if (that.cancel) {
            that.cancel.addEventListener('click', that.showHide);
        }
    }

    // przepisac na dwie metody - show oraz hide
    this.showHide = function () {
        if (!that.flag) {
            that.header.classList.add('is-mobile-navigation-active');
            that.activator.classList.add('is-active');
            that.overlay.classList.add('is-active');
            that.flag = true;
        } else {
            that.header.classList.remove('is-mobile-navigation-active');
            that.activator.classList.remove('is-active');
            that.overlay.classList.remove('is-active');
            that.flag = false;
        }
    };
};

module.exports = MobileNavigation;

},{}],5:[function(require,module,exports){
'use strict';

/*
    Example call:
        let modal = new Modal({
            modal:'.js-modal',      //* container holding modal
            modalActivator:'#burger-nav',       //* element that activates a Modal
            modalCancel: '.js-modal__cancel',       //* elements on which Modal will hide
        });
        modal.init();
*/
var Modal = function Modal(args) {
    var that = this;

    this.init = function () {
        this.cacheDom();
        bindEvents();
    };
    this.cacheDom = function () {
        this.modal = document.querySelector(args.modal);
        this.modalActivator = document.querySelector(args.modalActivator);
        this.modalCancel = this.modal.querySelectorAll(args.modalCancel);
    };
    function bindEvents() {
        that.modalActivator.addEventListener('click', showModal);
        that.modalCancel.forEach(function (elem) {
            elem.addEventListener('click', hideModal);
        });
    }
    function showModal() {
        that.modal.classList.add('active');
    }
    function hideModal() {
        that.modal.classList.remove('active');
    }
};

/*
    Example call:
        let modalForm = new ModalForm({
            modal:'.js-wpcf7-response-modal',       //* container holding modal
            formResponse:'.wpcf7-response-output',      //* wpcf7 response div
            modalCancel: '.js-modal__cancel',       //* elements on which Modal will hide
        });
        formModal.init();
*/
var ModalForm = function ModalForm(args) {
    var that = this;

    this.init = function () {
        this.cacheDom();
        bindEvents();
    };
    this.cacheDom = function () {
        this.modalFlag = false;
        this.modal = document.querySelector(args.modal);
        this.formResponse = document.querySelector(args.formResponse);
        this.modalCancel = this.modal.querySelectorAll(args.modalCancel);
    };
    function bindEvents() {
        that.formResponse.addEventListener('DOMNodeInserted', showModal);
        that.modalCancel.forEach(function (elem) {
            elem.addEventListener('click', hideModal);
        });
    }
    function showModal() {
        that.modal.querySelector('.js-modal__body-p').innerText = that.formResponse.innerText;
        that.modal.classList.add('is-active');
    }
    function hideModal() {
        that.modal.classList.remove('is-active');
    }
};

module.exports = { ModalForm: ModalForm, Modal: Modal };

},{}],6:[function(require,module,exports){
'use strict';

var ScrollAction = function ScrollAction(args) {
	var that = this;
	this.wrapper = args.wrapper;
	this.offset = args.offset ? args.offset : 0;
	this.classToAdd = args.classToAdd;
	this.secondWrapp = args.secondWrapper;

	this.init = function () {
		this.cacheDom();
		bindEvents();
	};
	this.cacheDom = function () {
		this.el = document.querySelector(this.wrapper);
		this.sWrapp = document.querySelector(this.secondWrapp);
	};
	function bindEvents() {
		window.addEventListener('scroll', decideAction);
		window.addEventListener('load', decideAction);
	}

	function decideAction() {
		if (typeof that.offset === "number") {
			makeAction(that.offset);
		} else if (typeof that.offset === "string") {
			var hookMoment = document.querySelector(that.offset);
			makeAction(document.querySelector(that.offset).offsetTop);
		}
	}

	function makeAction(argument) {
		var scrollTop = window.pageYOffset;
		if (scrollTop > argument) {
			that.el.classList.add(that.classToAdd);
			that.sWrapp.classList.add(that.classToAdd);
		} else {
			that.el.classList.remove(that.classToAdd);
			that.sWrapp.classList.remove(that.classToAdd);
		}
	}
};
module.exports = ScrollAction;

},{}],7:[function(require,module,exports){
'use strict';

var swiper_main = new Swiper('.js-main-swiper.swiper-container', {
  autoplay: {
    delay: 5000
  },
  effect: "fade",
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.js-main-swiper__pagination',
    type: 'bullets',
    clickable: 'true'
  }
});

var swiper_team = new Swiper('.js-team-swiper.swiper-container', {
  direction: 'vertical',
  slidesPerView: 4,
  scrollbar: {
    el: '.js-team-swiper__scrollbar',
    hide: false
  },
  // centeredSlides: true,
  navigation: {
    nextEl: '.js-team-swiper__next',
    prevEl: '.js-team-swiper__prev'
  }
  // autoplay: {
  //     delay: 5000
  // },
  // effect: "fade",
  // fadeEffect: {
  //   crossFade: true
  // },
  // pagination: {
  //   el: '.js-main-swiper__pagination',
  //   type: 'bullets',
  //   clickable: 'true',
  // }
});

},{}],8:[function(require,module,exports){
'use strict';

require('./modules/swipers.js');

var _cookieConsent = require('./modules/cookie-consent.js');

var _cookieConsent2 = _interopRequireDefault(_cookieConsent);

var _scrollAction = require('./modules/scroll-action.js');

var _scrollAction2 = _interopRequireDefault(_scrollAction);

var _mobileNavigation = require('./modules/mobile-navigation.js');

var _mobileNavigation2 = _interopRequireDefault(_mobileNavigation);

var _modal = require('./modules/modal.js');

var _accordion = require('./modules/accordion.js');

var _accordion2 = _interopRequireDefault(_accordion);

require('./modules/lazy-load');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
// import SmoothScroll from './modules/smooth-scroll.js';


var cookie = new _cookieConsent2.default({
  cookieWrapper: '.js-cookie-consent',
  cookieCancel: '.js-cookie-cancel',
  expirationDays: 30
});
cookie.init();

var accordion_team = new _accordion2.default({
  main_item: '.js-accordion__header',
  collapse: true
});
accordion_team.init();

// const smoothscroll = new SmoothScroll();
// smoothscroll.init();

var scrollAction = new _scrollAction2.default({
  wrapper: '.js-site-header',
  offset: 1,
  classToAdd: "is-sticky",
  secondWrapper: ".social-media"
});
scrollAction.init();

// let formModal = new ModalForm({
//   modal:'.js-wpcf7-response-modal',       //* container holding modal
//   formResponse:'.wpcf7-response-output',      //* wpcf7 response div
//   modalCancel: '.js-modal__cancel',       //* elements on which Modal will hide
// });
// formModal.init();


var mobileNav = new _mobileNavigation2.default({
  activator: '.js-burger-nav',
  cancel: '.js-mobile-nav-cancel',
  header: '.site-menu',
  overlay: '.js-site-menu__overlay'
});
mobileNav.init();

var menu_overlay = document.querySelector('.site-menu__overlay');
menu_overlay.addEventListener('click', mobileNav.showHide);

var el = document.querySelectorAll('.form-group input, .form-group textarea');

var _loop = function _loop(i) {
  var parent = el[i].parentNode;
  el[i].addEventListener('focus', function () {
    parent.nextSibling.classList.add('active');
  });
  el[i].addEventListener('focusout', function () {
    if (this.value === "") {
      parent.nextSibling.classList.remove('active');
    }
  });

  if (el[i].value !== "") {
    parent.nextSibling.classList.add('active');
  }
};

for (var i = 0; i < el.length; i++) {
  _loop(i);
}

function switchActive() {
  for (var i = 0; i < team_swiper_item.length; i++) {
    team_swiper_item[i].classList.remove('is-active');
    team_swiper_switch[i].classList.remove('is-active');
  }
  var index = [].concat(_toConsumableArray(team_swiper_item)).indexOf(this);
  this.classList.add('is-active');
  team_swiper_switch[index].classList.add('is-active');
  scrollTo($("#zespol"));
}

var team_swiper_item = document.getElementsByClassName('team-swiper__slide');
var team_swiper_switch = document.getElementsByClassName('team-item__switcher');

console.log(team_swiper_item);

for (var i = 0; i < team_swiper_item.length; i++) {
  team_swiper_item[i].addEventListener('click', switchActive);
}

if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  var _sr$reveal2;

  window.sr = ScrollReveal({ reset: false });
  sr.reveal('.js-sr-left', { duration: 1000, distance: '100%', origin: 'left' });
  sr.reveal('.js-sr-right', { duration: 1000, distance: '100%', origin: 'right' });
  sr.reveal('.js-sr-bot', { duration: 1000, distance: '100%', origin: 'bottom' });
  sr.reveal('.js-sr-bot--custom', _defineProperty({ duration: 500, distance: '50%', origin: 'bottom' }, 'distance', '50%'));
  sr.reveal('.js-sr-bot--delayed', (_sr$reveal2 = { duration: 1000, distance: '50%', origin: 'bottom' }, _defineProperty(_sr$reveal2, 'distance', '50%'), _defineProperty(_sr$reveal2, 'delay', 1000), _sr$reveal2));
  sr.reveal('.js-sr-rotated', { duration: 1000, rotate: { z: 90 }, scale: 2 }, 500);
  sr.reveal('.js-sr-bot--to-rotated', { duration: 1000, rotate: { z: 30 }, scale: 1.4, delay: 2000 }, 500);
}

$("a").on('click', function (event) {
  if (this.hash !== "") {
    event.preventDefault();
    var hash = this.hash;
    $('html, body').animate({
      scrollTop: $(hash).offset().top
    }, 800, function () {
      window.location.hash = hash;
    });
  }
});
function scrollTo($element) {
  $('html, body').animate({
    scrollTop: $element.offset().top
  }, 300);
  return false;
}

var menu_has_children = document.getElementsByClassName('menu-item-has-children');
var flag = false;
function slideSubMenu() {

  for (var _i = 0; _i < 2; _i++) {
    menu_has_children[_i].classList.remove('is-active');
  }
  if (flag) {
    this.querySelector('.sub-menu').classList.remove('is-active');
    flag = false;
  } else {
    this.querySelector('.sub-menu').classList.add('is-active');
    flag = true;
  }
}
for (var _i2 = 0; _i2 < 2; _i2++) {
  console.log(menu_has_children[_i2]);
  menu_has_children[_i2].addEventListener('click', slideSubMenu);
}

var myLazyLoad = new LazyLoad({
  elements_selector: ".lazy"
});

},{"./modules/accordion.js":1,"./modules/cookie-consent.js":2,"./modules/lazy-load":3,"./modules/mobile-navigation.js":4,"./modules/modal.js":5,"./modules/scroll-action.js":6,"./modules/swipers.js":7}]},{},[8]);
